import { Result } from 'domain/types';
import Logo from 'domain/entity/logo';
import ReadLogoClient from 'use-case/logos/read/readLogosClient';

export type LogoResult = Result<Logo[]>;
export type ReadLogo = () => Promise<LogoResult>;

export default (readLogoClient: ReadLogoClient): ReadLogo => (): Promise<LogoResult> => readLogoClient();
